'use client'

import { localDateTime } from '@/helpers/datetime'
import { useEffect, useState } from 'react'

function toDateTimeAttribute(datetime) {
  if (typeof datetime === 'string') return datetime

  if (datetime instanceof Date && !Number.isNaN(datetime.getTime())) {
    return datetime.toISOString()
  }

  if (typeof datetime?.toISOString === 'function') {
    try {
      return datetime.toISOString()
    } catch {
      return undefined
    }
  }

  return undefined
}

export default function LocalizedDateTime({
  datetime,
  timezone,
  format = 'll',
  fallback = null,
  emptyFallback = null,
  className,
}) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return fallback
  if (!datetime) return emptyFallback

  const formattedDateTime = localDateTime({
    datetime,
    timezone,
    format,
  })

  return (
    <time
      className={className}
      dateTime={toDateTimeAttribute(datetime)}
    >
      {formattedDateTime}
    </time>
  )
}
